import { Action } from '@ngrx/store';
import { Observable, from as observableFrom, of as observableOf } from 'rxjs';

import { UpdateQueueETagAction } from './queue.actions';

export function actionAndETagUpdate$<A extends Action>(
  action: A,
  etag: string | null,
): Observable<A | UpdateQueueETagAction> {
  return etag
    ? observableFrom([action, new UpdateQueueETagAction({ etag })])
    : observableOf(action);
}
